import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { withStyles, Button, CircularProgress, Typography, FormGroup, Paper, FormControl, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../../../sc-utilities';
import * as diagnoseCaseActions from "../../../../sc-settings/CustomerDiagnoseCase/store/customerDiagnoseCaseActions";
import * as adminDiagnoseCaseActions from "../../../../sc-admin/AdminDiagnoseCase/store/adminDiagnoseCaseActions";
import History from "../../../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    form: {
        width: '95%',
        margin: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    },
});

const FormFields = {
    phone_number: "phone_number"
}

const DeviceCaseSupportedDiagnoseDetailsLiveCall = (props) => {
    const { classes, translations, permissions, onUpdateAdminDiagnoseCaseParams, onUpdateCustomerDiagnoseCaseParams, activeCustomerID } = props;
    
    const diagnoseCase = props.location.state.redirectOptions?.rowData;
    
    const caseParams = diagnoseCase?.ThresholdParams || {};
    
    const isSystemDiagnoseCase = props.location.state?.redirectOptions?.isSystemDiagnoseCase ?? false;

    const initialValues = {
        phone_number: caseParams ? caseParams?.phone_number : '',
    }

    const hasDiagnoseCaseUpdatePermission = hasPermission(permissions, isSystemDiagnoseCase ? "diagnose_case_update" : "customer_diagnose_case_update");

    const formSettings = {
        Validation: {
            phone_number: Yup.string()
        },
        FormTitle: translations["update_parameters"] || "Update parameters",
        ButtonSubmit:
            hasDiagnoseCaseUpdatePermission ?
                {
                    Title: translations["save"] || "SAVE"
                } : null
    }

    const handleEdit = async (data) => {
        isSystemDiagnoseCase ?
            await onUpdateAdminDiagnoseCaseParams({ CaseParams: { phone_number: data.phone_number }, DiagnoseCaseID: diagnoseCase.DiagnoseCaseID }) :
            await onUpdateCustomerDiagnoseCaseParams({ CaseParams: { phone_number: data.phone_number }, DiagnoseCaseID: diagnoseCase.DiagnoseCaseID, ActiveCustomerID: activeCustomerID });
        History.goBack();
    }
    return (
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={handleEdit}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isSubmitting, isValid, dirty, handleSubmit, handleChange } = formikProps;
                    return (
                        <form className={classes.form} onSubmit={handleSubmit}>
                            <>
                                <Typography align='center' variant={"h5"}>{translations['live_call'] || 'Live call'}</Typography>
                                <FormGroup>
                                    <FormControl className={classes.formControl} margin={"dense"}>
                                        <TextField
                                            name={FormFields.phone_number}
                                            value={values.phone_number}
                                            label={`${translations["phone_number"] || "Phone number"}`}
                                            margin={"dense"}
                                            fullWidth
                                            type={"string"}
                                            onChange={handleChange}
                                        />
                                    </FormControl>
                                </FormGroup>

                                <div>
                                    {formSettings.ButtonSubmit ? (
                                        <Button
                                            fullWidth={true}
                                            className={classes.submit}
                                            variant="contained"
                                            color={formSettings.ButtonSubmit.Color}
                                            type="submit"
                                            style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        >
                                            {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null}
                                </div>
                            </>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
}
const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onUpdateAdminDiagnoseCaseParams: params => dispatch(adminDiagnoseCaseActions.updateAdminDiagnoseCaseParams(params)),
        onUpdateCustomerDiagnoseCaseParams: params => dispatch(diagnoseCaseActions.updateCustomerDiagnoseCaseParams(params)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DeviceCaseSupportedDiagnoseDetailsLiveCall));